import React from 'react';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonInput,
  IonItem,
  IonLabel,
  IonSpinner,
  IonText,
} from '@ionic/react';

interface ChangePasswordFormProps {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  isLoading: boolean;
  message: string;
  onCurrentPasswordChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: () => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  currentPassword,
  newPassword,
  confirmPassword,
  isLoading,
  message,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}) => {
  const loginCardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
  };

  const loginItemStyle: React.CSSProperties = {
    marginBottom: '1rem',
  };

  const loginButtonStyle: React.CSSProperties = {
    marginTop: '1.5rem',
    height: '48px',
    fontWeight: 600,
  };

  return (
    <IonCard style={loginCardStyle}>
      <IonCardHeader>
        <IonCardTitle>Change Password</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        {message && (
          <IonText color="medium">
            <p style={{ marginTop: 0, lineHeight: 1.5 }}>{message}</p>
          </IonText>
        )}

        <IonItem style={loginItemStyle}>
          <IonLabel position="stacked">Current Password</IonLabel>
          <IonInput
            type="password"
            value={currentPassword}
            placeholder="Enter your Current Password"
            onIonInput={(e) => onCurrentPasswordChange(e.detail.value ?? '')}
            onKeyUp={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
            disabled={isLoading}
            clearInput
          />
        </IonItem>

        <IonItem style={loginItemStyle}>
          <IonLabel position="stacked">New Password</IonLabel>
          <IonInput
            type="password"
            value={newPassword}
            placeholder="Enter a New Password"
            onIonInput={(e) => onNewPasswordChange(e.detail.value ?? '')}
            onKeyUp={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
            disabled={isLoading}
            clearInput
          />
        </IonItem>

        <IonItem style={loginItemStyle}>
          <IonLabel position="stacked">Confirm New Password</IonLabel>
          <IonInput
            type="password"
            value={confirmPassword}
            placeholder="Confirm New Password"
            onIonInput={(e) => onConfirmPasswordChange(e.detail.value ?? '')}
            onKeyUp={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
            disabled={isLoading}
            clearInput
          />
        </IonItem>

        <IonButton expand="full" onClick={onSubmit} disabled={isLoading} style={loginButtonStyle}>
          {isLoading ? (
            <>
              <IonSpinner name="crescent" />
              <span style={{ marginLeft: '8px' }}>Updating...</span>
            </>
          ) : (
            'Confirm'
          )}
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
};

export default ChangePasswordForm;
